import React from 'react';
import './onboarding-terms.scss';

const TermsAndConditions = () => {
  const offer_terms = [
    {
      displayText:
        'Kings Club offer is a corporate benefit to the employees (“Guest(s)”) whose organisation is registered with Burger King India.',
      id: 1
    },
    {
      displayText:
        'Upon registration to the aforesaid link, Guest can avail “15% off, upto Rs. 250” on minimum order value of Rs.200 on the registered phone number.',
      id: 2
    },
    {
      displayText:
        'Upon registration to the aforesaid link, Guest can avail “20% off, upto Rs. 1000” on minimum order value of Rs.1000 on the registered phone number.',
      id: 3
    },
    {
      displayText:
        'Kings Club offer will not be valid if tried to avail from a non-registered phone number.',
      id: 4
    },
    {
      displayText:
        'Kings Club offer is valid only on BK App Dine-in/ Takeaway only.',
      id: 5
    },
    {
      displayText:
        'Kings Club offer is not valid on BK App Delivery or on any other food aggregator platforms. ',
      id: 6
    },
    {
      displayText:
        'Kings Club offer is not valid in Airport & Franchised Burger King restaurants.',
      id: 7
    },
    {
      displayText:
        'Every order placed by Guest in dine-in/ take away by availing Kings Club offers are subject to taxes and charges as applicable.',
      id: 8
    },
    {
      displayText:
        'Burger King India maximum liability is restricted to the discount amount availed via the Kings Club offer.',
      id: 9
    },
    {
      displayText:
        'Burger King India has the right to cancel/reduce/amend/ modify /withdraw the offer at its sole discretion at any time, without giving any notice/intimation to the Guest. No claims/questions shall be entertained in this regard.',
      id: 10
    },
    {
      displayText:
        'Restaurant timings may vary for different locations. Restaurant operation is subject to State and Local Government guidelines. Orders with respect to permitted services/timings in different zones across cities.',
      id: 11
    },
    {
      displayText:
        'In case of any dispute, the courts in Mumbai will have exclusive jurisdiction.',
      id: 12
    },

    {
      displayText:
        'For any further information, you can contact by writing to us at customercare@rbrandsasia.com.',
      id: 13
    }
  ];

  return (
    <div className="termsandconditions__container">
      <div className="termsandconditions-heading">
        <b>TERMS AND CONDITIONS:</b>
      </div>
      <div className="termsandconditions">
        {offer_terms.map(term => (
          <p key={term.id}>
            <li>{term.displayText}</li>
          </p>
        ))}
      </div>
    </div>
  );
};
export default TermsAndConditions;
